(function () {
  'use strict';
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var TICK = '✓', DOT = '·';

  function parseEnd(str) {
    if (!str) return null;
    var d = new Date(String(str).trim().replace(' ', 'T'));
    return isNaN(d) ? null : d;
  }
  function countdownText(end) {
    var left = Math.max(0, end - new Date());
    return Math.floor(left / 86400000) + 'd ' + pad(Math.floor(left / 3600000) % 24) + 'h ' + pad(Math.floor(left / 60000) % 60) + 'm';
  }
  function tickCountdowns() {
    document.querySelectorAll('[data-ew-countdown]').forEach(function (el) {
      var end = parseEnd(el.getAttribute('data-ew-countdown'));
      if (!end) return;
      el.textContent = countdownText(end);
    });
  }
  function addWorkingDays(from, n) {
    var d = new Date(from); var k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) k++; }
    return d;
  }
  function deliveryRange(min, max) {
    var a = addWorkingDays(new Date(), min), b = addWorkingDays(new Date(), max);
    return DAYS[a.getDay()] + ' ' + a.getDate() + (a.getMonth() === b.getMonth() ? '' : ' ' + MONTHS[a.getMonth()]) + ' and ' + DAYS[b.getDay()] + ' ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }
  function fillDelivery(root) {
    (root || document).querySelectorAll('[data-ew-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '4', 10), max = parseInt(el.getAttribute('data-max') || '7', 10);
      el.textContent = deliveryRange(min, max);
    });
  }
  function initAnnouncements() {
    document.querySelectorAll('[data-ew-announce]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var msgs = bar.querySelectorAll('.ew-announce__msg'), dots = bar.querySelectorAll('.ew-announce__dots span');
      if (msgs.length < 2) return;
      var i = 0, speed = (parseInt(bar.getAttribute('data-speed') || '5', 10) || 5) * 1000;
      var show = function (n) {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      };
      var timer = setInterval(function () { show(i + 1); }, speed);
      var restart = function () { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, speed); };
      var prev = bar.querySelector('[data-ew-prev]'), next = bar.querySelector('[data-ew-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(i + 1); restart(); });
    });
  }
  function initGalleries() {
    document.querySelectorAll('[data-ew-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var box = g.querySelector('.ew-gallery__main');
      if (!box) return;
      var clearMedia = function () {
        box.querySelectorAll('video,iframe').forEach(function (x) { x.remove(); });
      };
      var getImg = function () {
        var img = box.querySelector('img');
        if (!img) { img = document.createElement('img'); img.alt = ''; box.insertBefore(img, box.firstChild); }
        return img;
      };
      g.querySelectorAll('.ew-gallery__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          var type = t.getAttribute('data-type') || 'image';
          clearMedia();
          var img = box.querySelector('img');
          if (type === 'image') {
            img = getImg();
            img.style.visibility = '';
            img.removeAttribute('srcset');
            img.src = t.getAttribute('data-src');
            if (t.getAttribute('data-srcset')) img.srcset = t.getAttribute('data-srcset');
            img.alt = t.getAttribute('data-alt') || img.alt;
          } else if (type === 'video') {
            if (img) img.style.visibility = 'hidden';
            var v = document.createElement('video');
            v.src = t.getAttribute('data-video'); v.poster = t.getAttribute('data-poster') || '';
            v.autoplay = true; v.muted = true; v.loop = true; v.playsInline = true; v.controls = true;
            v.setAttribute('playsinline', '');
            box.insertBefore(v, box.firstChild);
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else if (type === 'embed') {
            if (img) img.style.visibility = 'hidden';
            var f = document.createElement('iframe');
            f.src = t.getAttribute('data-embed'); f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
            box.insertBefore(f, box.firstChild);
          }
          g.querySelectorAll('.ew-gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }
  function initAddButtons() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ew-add]');
      if (!b) return;
      var submit = document.querySelector('.ew-pdp product-form [type="submit"]');
      if (submit && !submit.disabled) { e.preventDefault(); submit.click(); }
    });
  }
  /* Basket drawer: fill the slots rendered by snippets/cart-drawer.liquid */
  var cfg = window.EW_CART || null;
  function fill(el, html) {
    if (!el || el.dataset.ready) return false;
    el.dataset.ready = '1';
    if (html) el.innerHTML = html;
    return true;
  }
  function setFirstText(el, value) {
    if (!el || !value) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) {
        var want = value + (/\s$/.test(n.textContent) ? ' ' : '');
        if (n.textContent !== want) n.textContent = want;
        return;
      }
    }
  }
  function relabel(d) {
    setFirstText(d.querySelector('.drawer__heading'), cfg.title);
    setFirstText(d.querySelector('.ew-cd__sum-l'), cfg.total);
    var sm = d.querySelector('.ew-cd__sum-l small');
    if (sm && cfg.save && sm.textContent.indexOf(cfg.save) !== 0) sm.textContent = sm.textContent.replace(/^[^£$€0-9]*/, cfg.save + ' ');
    var bt = d.querySelector('.ew-cd__checkout span');
    if (bt && cfg.button && bt.textContent !== cfg.button) bt.textContent = cfg.button;
  }
  function cartExtras() {
    if (!cfg) return;
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    relabel(d);
    var hasItems = !!d.querySelector('.ew-ci');
    var changed = false;
    var promo = d.querySelector('[data-ew-cd-promo]');
    if (promo && !promo.dataset.ready) {
      var amount = promo.getAttribute('data-saving');
      changed = fill(promo, (cfg.saving && hasItems && !promo.hidden) ?
        '<span class="ew-cd__tick">' + TICK + '</span><div style="flex:1"><b>' + cfg.saving + '</b><br>' + (cfg.savingLine || '').replace('[amount]', amount) + '</div>' +
        (cfg.end ? '<div class="ew-cd__ends">Ends in<br><strong data-ew-countdown="' + cfg.end + '"></strong></div>' : '') : '') || changed;
    }
    var del = d.querySelector('[data-ew-cd-delivery]');
    if (del && !del.dataset.ready) {
      changed = fill(del, (cfg.delivery && hasItems) ?
        '<div class="ew-cd__del"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg><span><strong>' + cfg.delivery + '</strong> ' + DOT + ' arrives between <span data-ew-delivery data-min="' + cfg.min + '" data-max="' + cfg.max + '"></span></span></div>' : '') || changed;
    }
    changed = fill(d.querySelector('[data-ew-cd-avatars]'), hasItems ? (cfg.avatars || '') : '') || changed;
    changed = fill(d.querySelector('[data-ew-cd-trust]'), (cfg.trust && hasItems) ? '<div class="ew-cd__trust">' + cfg.trust.split(DOT).map(function (s) { return '<span>' + s.trim() + '</span>'; }).join('<span aria-hidden="true">' + DOT + '</span>') + '</div>' : '') || changed;
    if (changed) { fillDelivery(d); tickCountdowns(); }
  }
  function watchCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.ewWatch) return;
    drawer.dataset.ewWatch = '1';
    cartExtras();
    new MutationObserver(function () { cartExtras(); }).observe(drawer, { childList: true, subtree: true });
  }
  function init() { initAnnouncements(); initGalleries(); fillDelivery(); tickCountdowns(); watchCart(); }
  initAddButtons();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(tickCountdowns, 30000);
  document.addEventListener('shopify:section:load', init);
})();